import { Skeleton, Stack, styled } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
}));

export const StyledWrapper = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
}));

export const StyledHelperTextWrapper = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledDropdownSkeleton = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(7),
  width: '100%',
}));
StyledDropdownSkeleton.defaultProps = {
  variant: 'rectangular',
};

export const StyledHelperTextSkeleton = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(3),
  width: '30%',
}));
StyledHelperTextSkeleton.defaultProps = {
  variant: 'rectangular',
};
